export default __webpack_public_path__ + "static/media/SAM.8c3fc3b9.svg";